export class ResponseUtil {

    public static tratar(resultado) {
        if (resultado && resultado.records) {
            // console.log('REC =>', resultado.records);
            return (Array.isArray(resultado.records) ? resultado.records :  resultado.records.content);
        } else if (resultado) {
            return resultado;
        } else {
            return null;
        }
    }

}
